module.exports = __webpack_public_path__ + "img/user.a53173c1.svg";